import { ToastContainer } from "react-toastify";
import AppNavigation from "./navigation";
import useGlobalInputListener from "./helpers/inputListener";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Preloader from "./components/preloader";

function App() {
  const { showPreloader } = useSelector((state) => state.activePage);
  useGlobalInputListener();

  useEffect(() => {
    const handleFocus = (e) => {
      if (e.target.tagName === "INPUT") {
        // Browsers ignore "off", but they don't know what "flower-pot" or "no-fill" is
        e.target.setAttribute("autocomplete", "one-time-code");
      } else if (e.target.tagName === "TEXTAREA") {
        // Browsers ignore "off", but they don't know what "flower-pot" or "no-fill" is
        e.target.setAttribute("autocomplete", "new-password");
      }
    };

    document.addEventListener("focusin", handleFocus);
    return () => document.removeEventListener("focusin", handleFocus);
  }, []);
  return (
    <div className="bg-secondary min-h-[100vh]">
      <Preloader show={showPreloader} />
      <ToastContainer />
      <AppNavigation />
    </div>
  );
}

export default App;
